<template>
  <div class="media">
    <Avatar :url="user.avatar" :name="fullName" class="mr-3" />
    <div class="media-body">
      <h5 class="mt-0 mb-1">
        {{ fullName }}
        <span v-if="user.deletedAt" class="badge badge-pill badge-danger">
          Deactivated
        </span>
      </h5>
      <div class="user__email text-muted">{{ user.email }}</div>
      <div class="user__mobile" v-if="!!user.mobile">{{ user.mobile }}</div>
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/icons/IconAvatar";

export default {
  name: "UserListItemView",
  components: {
    Avatar
  },
  props: {
    tenant: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    },
    roles: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    fullName() {
      return this.user.firstName + " " + this.user.lastName;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .avatar {
  border-radius: 5rem;
  height: 5rem;
  width: 5rem;
}
</style>
